// eslint-disable-next-line import/no-cycle
import { getUserData } from '@/auth/utils'
import { USER_TYPE_COMPANY } from '@/const/userType'

export default function companyUsersOnly({ next, router }) {
  if (getUserData().usertype !== USER_TYPE_COMPANY && getUserData().usertype !== 'super') {
    return router.push('not-authorized')
  }

  return next()
}
